import React, { Suspense, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import { Canvas, useFrame, directionalLight } from "react-three-fiber";
import * as serviceWorker from "./serviceWorker";
import useStore from "./store";
import * as THREE from "three";
import { Physics, useSphere, useBox } from "use-cannon";
import "./index.scss";

// 3D Objects
import Scene from "./3D/Scene.js";
import Effects from "./3D/Effects.js";

// Debug
import Debugger from "./3D/Debugger.js";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Signup from "./UI/Signup.react";
import { initializeApp, analytics } from "firebase";
import useInitAudioVisualizer from "./util/useInitAudioVisualizer";
import UILayer from "./UI/UILayer.react";

function App() {
  const { fov, globeRadius, enableShadows } = useStore(
    (state) => state.mutation
  );
  const { ambient } = useStore((state) => state.debug);
  const actions = useStore((state) => state.actions);

  useInitAudioVisualizer();

  // const [globeRef] = useSphere(() => ({ type: 'Static', radius: globeRadius, mass: 1 }));

  return (
    <Router>
      <Switch>
        <Route path="/signup">
          <Signup />
        </Route>
        <Route path="/">
          <Canvas
            concurrent
            shadowMap
            onPointerMove={null}
            onClick={null}
            camera={{
              near: 0.01,
              far: 200,
              fov,
              position: [0, globeRadius + 20, -2],
            }}
            onCreated={({ gl, camera }) => {
              actions.init(camera);

              //   gl.gammaInput = true
              //   gl.toneMapping = THREE.Uncharted2ToneMapping
              //   gl.setClearColor(new THREE.Color('#020207'))
            }}
          >
            <Debugger />
            {ambient && <ambientLight intensity={0.25} />}
            <spotLight
              castShadow={enableShadows}
              color="cyan"
              intensity={1}
              position={[0, globeRadius + 20, 0]}
            />
            <fog attach="fog" args={["black", 1, 20]} />
            <Physics
              gravity={[0, -10, 0]}
              defaultContactMaterial={{
                contactEquationStiffness: 1e7,
              }}
            >
              <Scene />
            </Physics>
            <Effects />
          </Canvas>
          <UILayer />
          {/* Temp way of doing audio */}
          <audio id="audioPlayer"></audio>
        </Route>
      </Switch>
    </Router>
  );
}

initializeApp({
  apiKey: "AIzaSyA72pmSoYUd1k532xQ3MAkJuYda4MdEbPA",
  authDomain: "alone-together-35bfa.firebaseapp.com",
  databaseURL: "https://alone-together-35bfa.firebaseio.com",
  projectId: "alone-together-35bfa",
  storageBucket: "alone-together-35bfa.appspot.com",
  messagingSenderId: "63623793140",
  appId: "1:63623793140:web:f508cddc0789b1473491a1",
  measurementId: "G-4C0Z5DFS7C",
});
analytics();
ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
